import { FC } from 'react'
import { Minus, Plus } from 'lucide-react'

export const NumberStepper: FC<{
	value: number
	onChange: (value: number) => void
	title: string
	min?: number
	max?: number
}> = ({ value, onChange, min = 0, max = 100, title }) => {
	const handleChange = (delta: number) => {
		onChange(Math.max(min, Math.min(max, value + delta)))
	}

	return (
		<label className="training-modal-stepper">
			<span>{title}</span>
			<div className="training-modal-stepper-control">
				<button
					type="button"
					onClick={() => handleChange(-1)}
					aria-label={`Уменьшить ${title.toLowerCase()}`}
				>
					<Minus aria-hidden="true" />
				</button>
				<input
					type="number"
					value={value}
					min={min}
					max={max}
					onChange={(event) => {
						const nextValue = Number(event.target.value)
						if (Number.isFinite(nextValue)) {
							onChange(Math.max(min, Math.min(max, nextValue)))
						}
					}}
					aria-label={title}
				/>
				<button
					type="button"
					onClick={() => handleChange(1)}
					aria-label={`Увеличить ${title.toLowerCase()}`}
				>
					<Plus aria-hidden="true" />
				</button>
			</div>
		</label>
	)
}
